module.exports = require("core-js/modules/es.symbol.js");